// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PY6e","importantInfo":"styles_importantInfo__2ORDu"};